import { useState, useEffect } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import { toast } from "react-toastify";
// import { createStage, updateStage } from "../Api/StageMaster";
import {
  createStage,
  updateStage,
  addStageComment,
  fetchStageTimeline,
} from "../Api/StageMaster";
import { getUserById } from "../Api/Auth";

const StageModal = ({ show, onHide, stage, projectId, onStageSaved }) => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = String(userDetails?.userId);
  const orgId = String(userDetails?.organisationId);

  const [activeTab, setActiveTab] = useState("details");
  const [timeline, setTimeline] = useState([]);
  const [commentText, setCommentText] = useState("");
  const [loadingTimeline, setLoadingTimeline] = useState(false);

  const [formData, setFormData] = useState({
    stageName: "",
    stageDescription: "",
    stageProjectBelong: projectId || "",
    orgId: String(orgId) || "",
    createdBy: String(userId) || "",
    stageStartDateTime: "",
    stageEndDateTime: "",
    stageType: "",
  });

  console.log(formData);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (stage) {
      setFormData({
        stageName: stage.stageName || "",
        stageDescription: stage.stageDescription || "",
        stageType: stage.stageType || "",
        stageProjectBelong: stage.stageProjectBelong || projectId || "",
        orgId: stage.orgId || "",
        createdBy: stage.createdBy || userId?.toString() || "",
        stageStartDateTime: stage.stageStartDateTime
          ? stage.stageStartDateTime.slice(0, 16)
          : "",
        stageEndDateTime: stage.stageEndDateTime
          ? stage.stageEndDateTime.slice(0, 16)
          : "",
      });
    } else {
      setFormData({
        stageName: "",
        stageDescription: "",
        stageType: "",
        stageProjectBelong: projectId || "",
        orgId: String(orgId) || "",
        createdBy: userId?.toString() || "",
        stageStartDateTime: "",
        stageEndDateTime: "",
      });
    }

    setErrors({});
  }, [stage, show, projectId, userId]);

  // const validateForm = () => {
  //   const newErrors = {};

  //   if (!formData.stageName.trim()) {
  //     newErrors.stageName = "Stage name is required";
  //   }

  //   if (!formData.stageProjectBelong) {
  //     newErrors.stageProjectBelong = "Project ID is required";
  //   }

  //   if (!formData.orgId) {
  //     newErrors.orgId = "Organization ID is required";
  //   }

  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.stageName.trim()) {
      newErrors.stageName = "Stage name is required";
    }

    if (!formData.stageProjectBelong) {
      newErrors.stageProjectBelong = "Project ID is required";
    }

    if (!formData.orgId) {
      newErrors.orgId = "Organization ID is required";
    }

    if (formData.stageStartDateTime && formData.stageEndDateTime) {
      if (
        new Date(formData.stageEndDateTime) <=
        new Date(formData.stageStartDateTime)
      ) {
        newErrors.stageEndDateTime =
          "End date/time must be greater than Start date/time";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      const payload = {
        stageName: formData.stageName,
        stageDescription: formData.stageDescription,
        stageProjectBelong: formData.stageProjectBelong,
        orgId: formData.orgId,
        changedBy: userId,
        stageType: formData.stageType,
        stageStartDateTime: formData.stageStartDateTime
          ? new Date(formData.stageStartDateTime).toISOString()
          : null,
        stageEndDateTime: formData.stageEndDateTime
          ? new Date(formData.stageEndDateTime).toISOString()
          : null,
      };

      if (stage) {
        await updateStage(stage.stageId, payload);
        toast.success("Stage updated successfully");
      } else {
        await createStage(payload);
        toast.success("Stage created successfully");
      }

      onStageSaved();
      onHide();
    } catch (error) {
      console.error("Error saving stage:", error);
      toast.error(error.message || "Failed to save stage");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Clear error when user starts typing
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const handleAddComment = async () => {
    if (!commentText.trim()) return;

    try {
      await addStageComment({
        stageId: stage.stageId,
        commentText: commentText,
        orgId: orgId,
        createdBy: userId,
      });

      toast.success("Comment added");

      setCommentText("");
      loadTimeline();
    } catch (err) {
      toast.error("Failed to add comment");
    }
  };

  const loadTimeline = async () => {
    if (!stage?.stageId) return;

    try {
      setLoadingTimeline(true);

      const data = await fetchStageTimeline(stage.stageId);

      // collect unique userIds
      const userIds = [
        ...new Set(data.map((item) => item.createdBy).filter(Boolean)),
      ];

      const userMap = {};

      // fetch usernames
      await Promise.all(
        userIds.map(async (id) => {
          try {
            const res = await getUserById(id);
            userMap[id] = res.user.username;
          } catch {
            userMap[id] = id;
          }
        }),
      );

      // replace createdBy with username
      const updatedTimeline = data.map((item) => ({
        ...item,
        createdByName: userMap[item.createdBy] || item.createdBy,
      }));

      console.log(updatedTimeline, "updated timeline");

      setTimeline(updatedTimeline);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingTimeline(false);
    }
  };

  useEffect(() => {
    if (stage?.stageId) {
      loadTimeline();
    }
  }, [stage]);

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{stage ? "Edit Stage" : "Add New Stage"}</Modal.Title>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {/* Tabs */}
          <div className="mb-3">
            <Button
              variant={activeTab === "details" ? "primary" : "outline-primary"}
              className="me-2"
              onClick={() => setActiveTab("details")}
            >
              Stage Details
            </Button>

            {stage && (
              <Button
                variant={
                  activeTab === "activity" ? "primary" : "outline-primary"
                }
                onClick={() => setActiveTab("activity")}
              >
                Activity
              </Button>
            )}
          </div>

          {errors.general && <Alert variant="danger">{errors.general}</Alert>}

          {/* ============================= */}
          {/* STAGE DETAILS TAB */}
          {/* ============================= */}
          {activeTab === "details" && (
            <>
              <Form.Group className="mb-3">
                <Form.Label>Stage Name *</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.stageName}
                  onChange={(e) => handleChange("stageName", e.target.value)}
                  isInvalid={!!errors.stageName}
                  placeholder="Enter stage name"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.stageName}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Stage Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={formData.stageDescription}
                  onChange={(e) =>
                    handleChange("stageDescription", e.target.value)
                  }
                  placeholder="Enter stage description"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Stage Type *</Form.Label>
                <Form.Select
                  value={formData.stageType}
                  onChange={(e) => handleChange("stageType", e.target.value)}
                >
                  <option value="">-- Select Stage Type --</option>
                  <option value="Initiation">Initiation</option>
                  <option value="Planning">Planning</option>
                  <option value="Design">Design</option>
                  <option value="Development">Development</option>
                  <option value="Testing">Testing</option>
                  <option value="Deployment">Deployment</option>
                  <option value="Support">Support</option>
                  <option value="Maintenance">Maintenance</option>
                  <option value="Closure">Closure</option>
                </Form.Select>
              </Form.Group>

              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Stage Start Date & Time</Form.Label>
                    <Form.Control
                      type="datetime-local"
                      value={formData.stageStartDateTime}
                      onChange={(e) =>
                        handleChange("stageStartDateTime", e.target.value)
                      }
                    />
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Stage End Date & Time</Form.Label>
                    <Form.Control
                      type="datetime-local"
                      value={formData.stageEndDateTime}
                      onChange={(e) =>
                        handleChange("stageEndDateTime", e.target.value)
                      }
                      isInvalid={!!errors.stageEndDateTime}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.stageEndDateTime}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Project ID *</Form.Label>
                    <Form.Control
                      type="text"
                      value={formData.stageProjectBelong}
                      onChange={(e) =>
                        handleChange("stageProjectBelong", e.target.value)
                      }
                      isInvalid={!!errors.stageProjectBelong}
                      disabled={!!projectId}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.stageProjectBelong}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Organization ID *</Form.Label>
                    <Form.Control
                      type="text"
                      value={formData.orgId}
                      onChange={(e) => handleChange("orgId", e.target.value)}
                      isInvalid={!!errors.orgId}
                      disabled={!!orgId}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.orgId}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
              </div>

              <Form.Group className="mb-3">
                <Form.Label>Created By</Form.Label>
                <Form.Control type="text" value={formData.createdBy} disabled />
              </Form.Group>
            </>
          )}

          {/* ============================= */}
          {/* ACTIVITY TAB */}
          {/* ============================= */}
          {activeTab === "activity" && stage && (
            <div>
              {/* Add Comment */}
              <Form.Group className="mb-3">
                <Form.Label>Add Comment</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={commentText}
                  onChange={(e) => setCommentText(e.target.value)}
                  placeholder="Write a comment..."
                />
                <Button className="mt-2" onClick={handleAddComment}>
                  Add Comment
                </Button>
              </Form.Group>

              <hr />

              <h6>Activity Timeline</h6>

              {loadingTimeline ? (
                <p>Loading activity...</p>
              ) : timeline.length === 0 ? (
                <p>No activity yet</p>
              ) : (
                <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                  {timeline.map((item, index) => (
                    <div key={index} className="mb-3 p-2 border rounded">
                      {item.activityType === "COMMENT" && (
                        <>
                          <strong>{item.createdByName}</strong> commented:
                          <p>{item.commentText}</p>
                        </>
                      )}

                      {item.activityType === "LOG" && (
                        <>
                          <strong>{item.createdBy}</strong> changed
                          <b> {item.fieldName}</b>
                          <div>
                            {item.oldValue} → {item.newValue}
                          </div>
                        </>
                      )}

                      {item.activityType === "CREATE" && (
                        <>
                          <strong>{item.createdBy}</strong> created this stage
                        </>
                      )}

                      <small className="text-muted">
                        {item.createdOnDate} {item.createdOnTime}
                      </small>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={loading}>
            Cancel
          </Button>
          {activeTab === "details" && (
            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? "Saving..." : stage ? "Update Stage" : "Create Stage"}
            </Button>
          )}
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default StageModal;
